import { Params } from "@angular/router";

import {
    GridFilter,
    sortQueryParameters,
} from "@hermes/states/grid-filters-state";

export function getFacetQueryParameter(
    filter: GridFilter,
    facetUrlParameterName: string,
    queryParameters: Params,
    isCombinedFacetActivated: boolean,
): string {
    const facetQueryParameter: Params = {};
    Object.entries(queryParameters)
        .filter(([key, _value]) => !key.includes("facet_")) // Remove existing facet
        .filter(([key, _value]) => !key.includes("missingFacet")) // Remove missing facet parameter
        .filter((key) => !key.includes("page")) // Remove page parameter
        .filter((key) => !key.includes("s")) // Remove search parameter
        .forEach(([key, value]) => (facetQueryParameter[key] = value));

    if (facetUrlParameterName && filter) {
        facetQueryParameter[facetUrlParameterName] = filter.value;
    }
    if (isCombinedFacetActivated) {
        // We add the already existing facet parameter to the facetQueryParameter
        Object.entries(queryParameters)
            .filter(([key, _value]) => key.includes("facet_"))
            .forEach(([key, value]) => {
                if (!facetQueryParameter[key]) {
                    facetQueryParameter[key] = value;
                }
            });
    }
    let newUrlParameters: string = "";
    Object.entries(sortQueryParameters(facetQueryParameter)).forEach(
        ([key, value], index) => {
            if (index) {
                newUrlParameters += "&";
            }
            newUrlParameters += `${key}=${value}`;
        },
    );
    return newUrlParameters;
}
